'use client';

import tinycolor from "../../../external/tinycolor2/esm/tinycolor.js";
const hasContrast = (a, b, largeSizeOnly) => tinycolor.isReadable(a, b, {
  level: "AA",
  size: largeSizeOnly ? "large" : "small"
});
export {
  hasContrast
};
